<template>
  <v-container>
    <v-row>
      <v-col cols="6" xl="6" lg="12" class="py-0">
        <div class="black--text mt-6 sigfloBodyLarge">
          {{ configurator.currentSubsystemStepComponent ? configurator.currentSubsystemStepComponent.description : '' }}
        </div>
      </v-col>
      <v-col cols="6" xl="6" lg="12" class="pb-0 pt-5 text-right d-flex" justify="end" v-if="!hasSelectedProduct">
        <v-spacer class="d-none d-xl-flex" />
        <!-- Filters -->
        <div class="pt-2 mr-2 sigfloBodySmall400 textMuted" v-show="hasSettings">Filter by :</div>
        <div
          v-for="setting in configurator.currentSubsystemStepComponent.componentSettingModels"
          :key="setting.componentSettingDefinitionId"
        >
          <div v-if="setting.controlType.toLowerCase() === 'int'">
            <v-text-field
              solo
              dense
              flat
              class="filter sigfloBodySmall400 elevation-0 mr-2"
              v-model="setting.value"
              :rules="validation.numeric"
              :suffix="setting.valueSuffix"
              :label="setting.label"
              value=""
              :hint="setting.description"
            ></v-text-field>
          </div>
          <div v-if="setting.controlType.toLowerCase() === 'yesno'">
            <v-checkbox v-model="setting.value" @change="updateComponentSettingModel($event, setting)"></v-checkbox>
          </div>
          <div
            v-if="
              setting.controlType.toLowerCase() === 'dropdownlist' ||
              setting.controlType.toLowerCase() === 'multiselect'
            "
          >
            <v-select
              solo
              dense
              flat
              class="filter sigfloBodySmall400 elevation-0 mr-2"
              :rules="setting.required ? validation.selection : []"
              v-model="setting.value"
              :hint="setting.description"
              :items="getComponentSettingValueModels(setting)"
              item-text="label"
              item-value="value"
              :label="setting.name"
              @change="updateComponentSettingModel($event, setting)"
            ></v-select>
          </div>
        </div>
        <!-- Sorting -->
        <v-select
          solo
          dense
          flat
          class="filter sigfloBodySmall400 elevation-0 mr-2"
          v-model="sortBy"
          :items="sortByOptions"
          item-text="label"
          item-value="value"
          label="Sort By"
        ></v-select>
        <!-- Grid View -->
        <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="#FFFFFF" class="elevation-0 px-0 mr-2 tileButton" v-on="on">
                <v-icon>mdi-view-grid-outline</v-icon>
              </v-btn>
            </template>
            <span>Grid View</span>
          </v-tooltip> -->
        <!-- List View -->
        <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="#FFFFFF" class="elevation-0 px-0 tileButton" v-on="on">
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </template>
            <span>List View</span>
          </v-tooltip> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        sortByOptions: [
          { label: 'Price: Low to High', value: 'priceasc' },
          { label: 'Price: High to Low', value: 'pricedesc' }
        ]
      };
    },
    computed: {
      ...mapState(['configurator']),
      sortBy: {
        get() {
          return this.configurator.productSortBy;
        },
        set(value) {
          this.$store.commit('configurator/setProductSortBy', value);
        }
      }
    },
    methods: {
      /**
       * Builds the dropdown list objects for specified setting
       */
      getComponentSettingValueModels: function (setting) {
        var items = [...setting.componentSettingValueModels];
        if (items.filter((x) => x.label.toLowerCase() == 'none').length == 0)
          items.unshift({ label: 'None', value: null, published: true });
        return items;
      },
      /**
       * Updates the component setting model with the new value and selected record.
       * If the new value is an array, it is converted to a delimited string.
       * The updated component setting model is committed to the Vuex store.
       * If the selected record's control type is 'dropdownlist' and the current subsystem step's product type ID is a number,
       * the current step is refreshed by calling the 'saveAndGoToStep' method.
       *
       * @param {any} newValue - The new value to update the component setting model with.
       * @param {object} selectedRecord - The selected record to update the component setting model with.
       * @returns {void}
       */
      updateComponentSettingModel: function (newValue, selectedRecord) {
        if (Array.isArray(newValue)) newValue = newValue.join(',');

        this.$store.commit('configurator/updateComponentSettingModel', {
          componentIndex: this.getCurrentStepIndex(),
          updatedComponentSettingModel: selectedRecord,
          newValue: newValue == null ? null : newValue.toString()
        });

        if (
          (selectedRecord.controlType.toLowerCase() == 'dropdownlist' ||
            selectedRecord.controlType.toLowerCase() == 'multiselect') &&
          !isNaN(this.configurator.currentSubsystemStepComponent.productTypeId)
        ) {
          //this.saveAndGoToStep(this.getCurrentStepIndex());
          this.saveSubsystemStepProgress('subsystem');
        }
      }
    }
  };
</script>

<style scoped>
  .filter {
    max-width: 180px;
  }
  .tileButton {
    min-width: 36px !important;
    max-width: 36px !important;
  }
</style>
